import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "ea_recently_viewed_v1";
const MAX_ITEMS = 12;

/**
 * Persistent list of recently-viewed product IDs (most-recent-first).
 * Stored in localStorage so it survives reloads / tabs.
 */
function readIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x) => typeof x === "string");
  } catch (_) {
    return [];
  }
}

function writeIds(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_ITEMS)));
  } catch (_) { /* storage may be unavailable */ }
}

export function useRecentlyViewed() {
  const [ids, setIds] = useState(() => readIds());

  // Re-sync when other tabs update.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setIds(readIds());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const track = useCallback((productId) => {
    if (!productId) return;
    const current = readIds();
    const next = [productId, ...current.filter((id) => id !== productId)].slice(0, MAX_ITEMS);
    writeIds(next);
    setIds(next);
  }, []);

  return { ids, track };
}
